// Use the Laravel API endpoint
const API_BASE_URL = 'https://api.quali-d.com'

console.log('API Base URL:', API_BASE_URL)

export class AuthService {
  static async login (credentials) {
    try {
      console.log('Attempting login to:', `${API_BASE_URL}/login`)
      console.log('Credentials:', { country_code: credentials.country_code, phone: credentials.phone, password: '***' })

      const response = await fetch(`${API_BASE_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        mode: 'cors',
        body: JSON.stringify({
          country_code: credentials.country_code,
          phone: credentials.phone,
          password: credentials.password
        })
      })

      console.log('Response status:', response.status)
      console.log('Response headers:', response.headers)

      // Check if response is actually JSON
      const contentType = response.headers.get('content-type')
      console.log('Content-Type:', contentType)

      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text()
        console.log('Non-JSON response:', text.substring(0, 200))
        throw new Error('Server returned HTML instead of JSON. Check API endpoint.')
      }

      const data = await response.json()
      console.log('Response data:', data)

      if (!response.ok) {
        throw new Error(data.message || 'Login failed')
      }

      // Check for different success response formats
      console.log('Checking response format...')
      console.log('data.status:', data.status)
      console.log('data.success:', data.success)

      // Handle both possible success formats
      const isSuccess = data.status === 'success' || data.success === true

      if (!isSuccess) {
        throw new Error(data.message || 'Invalid credentials')
      }

      // Structure user data from API response
      if (data.success && data.token) {
        data.user = {
          id: data.user_id,
          name: data.name,
          phone: data.phone,
          email: data.email,
          role: data.role_name,
          role_id: data.role_id, // Keep original property name for compatibility
          roleId: data.role_id, // Also keep camelCase for backward compatibility
          company: data.company_name,
          plan: data.plan_name,
          planId: data.plan_id,
          country_code: data.country_code
        }
      } else if (!data.user && !data.token) {
        console.warn('API response missing user data or token, creating mock user')
        data.user = {
          name: 'Test User',
          phone: credentials.phone,
          role: 'admin',
          role_id: 1,
          company: 'Test Company',
          plan: 'Test Plan'
        }
        data.token = 'mock_token_' + Date.now()
      }

      console.log('Final response data:', data)
      return data
    } catch (error) {
      console.error('Login error:', error)

      if (error instanceof TypeError && error.message.includes('fetch')) {
        throw new Error('Network error. Unable to connect to the server. This might be a CORS issue.')
      }

      if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) {
        throw new Error('Connection failed. Please check if the API server is running and CORS is configured.')
      }

      throw error
    }
  }

  static setAuthData (authData) {
    if (authData.token) {
      localStorage.setItem('auth_token', authData.token)
      localStorage.setItem('token', authData.token) // Also store as 'token' for API calls
    }
    if (authData.user) {
      localStorage.setItem('user_data', JSON.stringify(authData.user))
      localStorage.setItem('user', JSON.stringify(authData.user)) // Also store as 'user' for compatibility
    }
  }

  static getAuthToken () {
    return localStorage.getItem('auth_token')
  }

  static getUserData () {
    const userData = localStorage.getItem('user_data')
    return userData ? JSON.parse(userData) : null
  }

  static isAuthenticated () {
    return !!this.getAuthToken()
  }

  static logout () {
    localStorage.removeItem('auth_token')
    localStorage.removeItem('user_data')
    localStorage.removeItem('token')
    localStorage.removeItem('user')
  }

  static async makeAuthenticatedRequest (url, options = {}) {
    const token = this.getAuthToken()

    const headers = {
      'Content-Type': 'application/json',
      ...options.headers
    }

    if (token) {
      headers.Authorization = `Bearer ${token}`
    }

    return fetch(url, {
      ...options,
      headers
    })
  }

  static async getUserCredits () {
    try {
      const token = this.getAuthToken()
      if (!token) {
        throw new Error('No authentication token found')
      }

      console.log('Fetching user credits with token:', token.substring(0, 10) + '...')

      // Note: This endpoint still uses the old API - should be migrated to Laravel API later
      const response = await fetch('https://dashboard.quali-d.com/api/get_my_credit.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        mode: 'cors',
        body: JSON.stringify({
          token: token
        })
      })

      console.log('Credits response status:', response.status)

      if (!response.ok) {
        throw new Error('Failed to fetch user credits')
      }

      const data = await response.json()
      console.log('Credits response data:', data)

      // API returns array with single object containing id and minutes
      if (Array.isArray(data) && data.length > 0) {
        return {
          credits: data[0].minutes || 0,
          id: data[0].id
        }
      }

      return { credits: 0, id: null }
    } catch (error) {
      console.error('Error fetching user credits:', error)
      return { credits: 0, id: null, error: error.message }
    }
  }
}
